import { alpha, styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';

const LabeledToolbar = styled(Toolbar)(({ theme }) => ({
    '&.MuiToolbar-root': {
        paddingLeft: 0,
        paddingRight: 0,
    },
    '& p': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        color: `${alpha(theme.palette.text.primary, 0.7)}`,
        fontSize: 12,
        textAlign: 'center',
        marginTop: -5,
        marginBottom: 0,
        textTransform: 'none',
    },
    '& button': {
        display: 'block',
        textAlign: 'center',
        margin: 0,
        color: 'inherit',
        '& .MuiButton-startIcon': {
            marginRight: 0,
            marginLeft: 0,
            maxHeight: 25.75,
        }
    },
    '&.MuiToolbar-gutters': {
        minHeight: 57,
    },
}));

export {
    LabeledToolbar as default,
};
